import { AnalogueModelDetail, UploadFileType } from '../api/generated';
import { client } from '../api/generated/client.gen';
import { useDownloadStore } from '../stores/DownloadStore';

const { setProgress } = useDownloadStore.getState();

export const GetFetchIniFileAxios = async (
  analogueModel: AnalogueModelDetail,
) => {
  const fileType = UploadFileType.INI_DATA;
  setProgress(fileType, 0);
  try {
    const response = await client.instance.get(
      `/api/v1/downloads/${analogueModel.analogueModelId}/ini`,
      {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (progressEvent.loaded * 100) / progressEvent.total!,
          );
          setProgress(fileType, percentCompleted);
        },
      },
    );

    if (response.data) {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = fileURL;
      link.download =
        analogueModel.fileUploads.find(
          (x) => x.uploadFileType === UploadFileType.INI_DATA,
        )?.originalFileName || 'file.ini';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);
    }
  } finally {
    setProgress(fileType, undefined);
  }
};

export const GetFetchNcFileAxios = async (
  analogueModel: AnalogueModelDetail,
) => {
  const fileType = UploadFileType.NET_CDF;
  setProgress(fileType, 0);
  try {
    const response = await client.instance.get(
      `/api/v1/downloads/${analogueModel.analogueModelId}/nc`,
      {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (progressEvent.loaded * 100) / progressEvent.total!,
          );
          setProgress(fileType, percentCompleted);
        },
      },
    );

    if (response.data) {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = fileURL;
      link.download =
        analogueModel.fileUploads.find(
          (x) => x.uploadFileType === UploadFileType.NET_CDF,
        )?.originalFileName || 'file.nc';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);
    }
  } finally {
    setProgress(fileType, undefined);
  }
};

export const GetFetchResqmlFileAxios = async (
  analogueModel: AnalogueModelDetail,
) => {
  const fileType = UploadFileType.RES_QML_DATA;
  setProgress(fileType, 0);
  try {
    const response = await client.instance.get(
      `/api/v1/downloads/${analogueModel.analogueModelId}/resqml`,
      {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (progressEvent.loaded * 100) / progressEvent.total!,
          );
          setProgress(fileType, percentCompleted);
        },
      },
    );

    if (response.data) {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = 'Resqml.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);
    }
  } finally {
    setProgress(fileType, undefined);
  }
};
